export const FETCH_PRODUCT_DATA = "FETCH_PRODUCT_DATA";
export const FETCH_PRODUCT_SALE_DATA = "FETCH_PRODUCT_SALE_DATA";
export const FETCH_PURCHASE_ORDER_DATA = "FETCH_PURCHASE_ORDER_DATA";
